import React, {useEffect} from 'react';
import {
  Dimensions,
  // Platform,
  StyleSheet,
  TouchableOpacity,
  View,
} from 'react-native';
import Animated, {
  interpolateColor,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import {useFocusEffect} from '@react-navigation/native';
import {observer} from 'mobx-react-lite';

import {useWebScreenDimensions} from '../hooks/useWebScreenDimensions';
import {useStores} from '../stores/use-stores';

const RightSideFilters = observer(({children, menu, menuWidthProportion}) => {
  const {globalStore} = useStores();

  const SLIDE_WIDTH_PROPORTION = menuWidthProportion || 0.5;
  const screenDimensions = useWebScreenDimensions();

  // TODO: FIX!!!!!!!
  let width = 0;
  // if (Platform.OS === 'web') {
  //   width = screenDimensions.appWidth;
  // } else {
  width = Dimensions.get('window').width;
  // }

  const styles = StyleSheet.create({
    slidingView: {
      width: width * (1 + SLIDE_WIDTH_PROPORTION),
      flexDirection: 'row',
      flex: 1,
    },
    mainView: {
      width,
    },
    overlay: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
    fullTouchable: {
      width: '100%',
      height: '100%',
    },
    hiddenView: {
      width: width * SLIDE_WIDTH_PROPORTION,
    },
    menuContainer: {
      width: width * SLIDE_WIDTH_PROPORTION,
      flex: 1,
      flexWrap: 'wrap',
      borderLeftWidth: 0.5,
      borderLeftColor: 'black',
    },
  });

  const rightVal = useSharedValue(0);
  const colorVal = useSharedValue(0);
  const displayVal = useSharedValue('none');

  const animatedSlideStyle = useAnimatedStyle(() => {
    return {
      right: rightVal.value,
    };
  });

  const background = useAnimatedStyle(() => {
    return {
      backgroundColor: interpolateColor(colorVal.value, [0, 1], ['#00000000', '#00000090'], 'RGB'),
      display: displayVal.value,
    };
  });

  useEffect(() => {
    if (globalStore.filtersVisible) {
      rightVal.value = withTiming(width * SLIDE_WIDTH_PROPORTION, {
        duration: 250,
      });
      displayVal.value = 'flex';
      colorVal.value = withTiming(1, {duration: 250});
    } else {
      rightVal.value = withTiming(0, {duration: 250});
      colorVal.value = withTiming(0, {duration: 250}, () => (displayVal.value = 'none'));
    }
  }, [
    SLIDE_WIDTH_PROPORTION,
    colorVal,
    displayVal,
    globalStore.filtersVisible,
    rightVal,
    screenDimensions.appWidth,
    width,
  ]);

  useFocusEffect(
    React.useCallback(() => {
      return () => {
        globalStore.setFiltersVisible(false);
      };
      // TODO: Important: error  React Hook React.useCallback has a missing dependency: 'globalStore'. Either include it or remove the dependency array
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []),
  );

  return (
    <Animated.View
      style={[styles.slidingView, animatedSlideStyle]}
      testID="right-side-filters-parent-animated-view">
      <View style={styles.mainView} testID="right-side-filters">
        {children}
        <Animated.View style={[styles.overlay, background]}>
          <TouchableOpacity
            onPress={() => globalStore.setFiltersVisible(false)}
            style={styles.fullTouchable}
          />
        </Animated.View>
      </View>
      <View style={styles.hiddenView} testID="right-side-filters-hidden-view-for-menu">
        <View
          style={styles.menuContainer}
          testID="right-side-filters-hidden-view-for-menu-container">
          {menu}
        </View>
      </View>
    </Animated.View>
  );
});

export default RightSideFilters;
